import { type FC } from 'react'
import { useSchwabContactSync } from '../IntegrationSpecificSettings/Schwab/hooks'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

export const SchwabCrmSettingsProvider: FC<CrmSettingsProviderProps> = ({ children }) => {
  const contact = useSchwabContactSync()

  const settings: CrmIntegrationSettings = {
    contactSync: contact.autoSync ?? false,
    calendarSync: false,
    isSyncDisabled: contact.isSyncDisabled,
    isFetching: contact.isFetching,
    isSaving: contact.isSaving,
    save: async (patch) => {
      if (patch.contactSync !== undefined) {
        await contact.saveAutoSync(patch.contactSync)
      }
    },
  }

  return <>{children(settings)}</>
}
